import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { AuthService } from '../_services/auth.service';
import { Router } from '@angular/router';
import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { User } from '../_models/user';
import { AsyncPipe } from '@angular/common';
import { MatButton } from '@angular/material/button';


@Component({
    selector: 'app-home',
    templateUrl: './no-access.component.html',
    styleUrls: ['./no-access.component.css'],
    imports: [AsyncPipe, MatButton]
})
export class NoAccessComponent {

  user: Observable<User | null>;
  requestingAccess = false;
  requestMessage: string | null = null;
  requestError: string | null = null;

  constructor(
    private titleService: Title,
    public auth: AuthService,
    private router: Router
  ) {
    this.titleService.setTitle('Home' + ' | NPC Admin');
    this.user = this.auth.user.pipe(
      tap(user => {
        if (user && (user.admin || user.schools?.length)) {
          this.router.navigateByUrl(this.auth.getHomeUrlTree(user));
        }
      })
    );
  }

  async requestAccess(): Promise<void> {
    this.requestingAccess = true;
    this.requestMessage = null;
    this.requestError = null;

    const error = await this.auth.requestNpcAdminAccess();
    this.requestingAccess = false;

    if (error) {
      this.requestError = error;
      return;
    }

    this.requestMessage =
      'Your request was sent to College Board. You will receive an email when your account has been authorized.';
  }

}
